/*************************
 * Author : Matthieu ROBIN
 *************************/
import React, { FunctionComponent } from "react";
import { Link } from "react-router";
import img from "../images/404_not_found.svg";

const PageNotFound: FunctionComponent = () => {
  return (
    <div className="center" style={{ marginTop: 50 }}>
      <img alt="Page non trouvée" src={img} width="250" />
      <h2>Cette page n'existe pas !</h2>
      <Link className="waves-effect waves-teal btn-flat" to="/">
        Retour à l'accueil
      </Link>
    </div>
  );
};

export default PageNotFound;
